module.exports = __webpack_public_path__ + "static/img/WIL-MALADY.c5c27d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/WIL-MALADY.jpg
// module id = Pdbx
// module chunks = 0